export enum NotificationType {
  GameApplicationApproved = 'game-application-approved',
  GameApplicationRejected = 'game-application-rejected',
  GameReminder = 'game-reminder',
  HostedGameReminder = 'hosted-game-reminder',
  GameCanceled = 'game-canceled',
  GameUpdated = 'game-updated',
  HostedGameNewApplication = 'hosted-game-new-application',
  HostedGamePlayerLeft = 'hosted-game-player-left',
  NewGameByAlert = 'new-game-from-alert',
  GameFinished = 'game-finished',
  HostedGameFinished = 'hosted-game-finished',
  GamePlayerRemovedByHost = 'game-player-removed-by-host',
  GameInvitationRecived = 'game-invitation-received',
  ChatNewMessage = 'chat-new-message',
  CustomNotification = 'custom-notification',
  HostedGamePlayerAutoApproved = 'hosted-game-player-auto-approved',
  TeamMemberAddedByHost = 'team-member-added-by-host',
  UserPenaltyReceived = 'user-penalty-received',
  GameLineupsCreated = 'game-lineups-created',
  NewTrophyReceived = 'new-trophy-received',
  NewCommentReceived = 'new-comment-received',

  // Player actionPush notifications
  ActionPushPlayerCollectPoints = 'action-push-player-collect-points',
  ActionPushPlayerInvitePlayers = 'action-push-player-invite-players',
  ActionPushPlayerInactive = 'action-push-player-inactive',
  ActionPushPlayerAchievements = 'action-push-player-achievements',
  ActionPushPlayerInactive2 = 'action-push-player-inactive-2',
  ActionPushPlayerAlerts = 'action-push-player-alerts',

  // Player after action actionPush notifications
  ActionPushPlayerCommentsAndPenalties = 'action-push-player-comments-and-penalties',

  // Host actionPush notifications
  ActionPushHostCollectPoints = 'action-push-host-collect-points',
  ActionPushHostInvitePlayers = 'action-push-host-invite-players',
  ActionPushHostInactive = 'action-push-host-inactive',
  ActionPushHostAchievements = 'action-push-host-achievements',

  // Host after action actionPush notifications
  ActionPushHostTeamsDrawing = 'action-push-host-teams-drawing',
  ActionPushHostCommentsAndPenalties = 'action-push-host-comments-and-penalties',
  ActionPushHostCreateGroup = 'action-push-host-create-group',
  ActionPushHostInvitePreviousPlayers = 'action-push-host-invite-previous-players'
}

export const OnboardingNotificationTypes: NotificationType[] = [
  NotificationType.ActionPushPlayerCollectPoints,
  NotificationType.ActionPushPlayerInvitePlayers,
  NotificationType.ActionPushPlayerInactive,
  NotificationType.ActionPushPlayerAchievements,
  NotificationType.ActionPushPlayerInactive2,
  NotificationType.ActionPushPlayerAlerts,
  NotificationType.ActionPushPlayerCommentsAndPenalties,
  NotificationType.ActionPushHostCollectPoints,
  NotificationType.ActionPushHostInvitePlayers,
  NotificationType.ActionPushHostInactive,
  NotificationType.ActionPushHostAchievements,
  NotificationType.ActionPushHostTeamsDrawing,
  NotificationType.ActionPushHostCommentsAndPenalties,
  NotificationType.ActionPushHostCreateGroup,
  NotificationType.ActionPushHostInvitePreviousPlayers
];
